export enum SchemaElementKind {
  Datapoint = 'datapoint',
  Section = 'section',
  Tuple = 'tuple',
  List = 'list',
  Table = 'table',
}
